import { FormGroupContainer, FormRow } from 'components/inputs'
import {
  CustomSelect,
  RenderSearchItemProps,
  useCustomSelectStateFromItemSource,
} from 'components/inputs/CustomSelect'
import SearchResultItem from 'components/inputs/CustomSelect/SearchResultItem'
import { observer } from 'mobx-react'
import React from 'react'
import { truncate } from 'lodash'
import ClientTeamInputEditorViewModel from './ClientTeamInputEditorViewModel'
import TeamMember from 'iam/models/TeamMember'

interface ClientTeamInputEditorProps {
  vm: ClientTeamInputEditorViewModel
}

export default observer(function ClientTeamInputEditor({
  vm,
}: ClientTeamInputEditorProps) {
  const selectClientTeamProps = useCustomSelectStateFromItemSource({
    itemSource: vm.fetchClientTeamMembers,
    debounce: 250,
  })

  return (
    <>
      <FormRow>
        <FormGroupContainer
          model={vm}
          field="clientTeamMember"
          error={vm.validationClientTeamMember.getError('clientTeamMember')}
          label="New Client Team"
          help={
            <>
              Make sure that the Client and/or Team you are transferring to has
              a valid billing method!
            </>
          }
        >
          <CustomSelect
            {...selectClientTeamProps}
            data-test="transfer-to-client-team-dropdown"
            multi={false}
            itemToString={(i) => truncate(i.team.name, { length: 60 })}
            placeholder="Select new client team"
            value={vm.clientTeamMember}
            onChange={vm.setClientTeamMember}
            renderSearchItem={(props) => (
              <TransferToClientTeamSearchItem {...props} />
            )}
          />
        </FormGroupContainer>
      </FormRow>
    </>
  )
})

interface TransferToClientTeamSearchItem
  extends RenderSearchItemProps<TeamMember> {}

const TransferToClientTeamSearchItem = observer(
  React.forwardRef(
    (
      { item, itemToString, ...itemProps }: TransferToClientTeamSearchItem,
      ref: React.Ref<any>,
    ) => {
      return (
        <SearchResultItem
          ref={ref}
          {...itemProps}
          data-test={
            'transfer-to-client-team-option-' +
            (item?.team.id?.toLowerCase() || item?.team.name.toLowerCase())
          }
        >
          {item?.team.name}
        </SearchResultItem>
      )
    },
  ),
)
